import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { LayoutComponent } from './layout/layout.component';

import { DealershipModule } from './pages/dealership/dealership.module';
import { DistributorModule } from './pages/distributor/distributor.module';
import { AutomakerModule } from './pages/automaker/automaker.module';
import { DistributorStockModule } from './pages/distributor-stock/distributor-stock.module';
import { MichelinStockModule } from './pages/michelin-stock/michelin-stock.module';
import { UserModule } from './pages/user/user.module';
import { OrderModule } from './pages/order/order.module';
import { DashboardModule } from './pages/dashboard/dashboard.module';
import { AuthenticationModule } from './pages/authentication/authentication.module';
import { authGuard } from './shared/guards/auth/auth.guard';
import { ErrorModule } from './pages/error/error.module';
import { UserProfileModule } from './pages/user-profile/user-profile.module';
import { ReportModule } from './pages/report/report.module';
import { HomeModule } from './pages/home/home.module';
import { CityAttributeModule } from './pages/city-attribute/city-attribute.module';

export const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    canActivate: [authGuard],
    children: [
      { path: '', loadChildren: () => HomeModule },
      { path: 'dashboard', loadChildren: () => DashboardModule },
      { path: 'reports', loadChildren: () => ReportModule },
      { path: 'error', loadChildren: () => ErrorModule },
      { path: 'dealerships', loadChildren: () => DealershipModule },
      { path: 'distributors', loadChildren: () => DistributorModule },
      { path: 'automakers', loadChildren: () => AutomakerModule },
      { path: 'des-stock', loadChildren: () => DistributorStockModule },
      { path: 'michelin-stock', loadChildren: () => MichelinStockModule },
      { path: 'users', loadChildren: () => UserModule },
      { path: 'user-profiles', loadChildren: () => UserProfileModule },
      { path: 'orders', loadChildren: () => OrderModule },
      { path: 'city-attributes', loadChildren: () => CityAttributeModule }
    ]
  },
  { path: 'auth', canActivate: [authGuard], loadChildren: () => AuthenticationModule },
  { path: '**', redirectTo: '', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })],
  exports: [RouterModule]
})
export class AppRoutingModule {}
